import React from "react";
import { useTranslation } from "react-i18next";

const Ourmission = () => {
  const { t } = useTranslation();

  const cardData = [
    {
      title: t("aboutUs.mission.cardOne.title"),
      description: t("aboutUs.mission.cardOne.description"),
    },
    {
      title: t("aboutUs.mission.cardTwo.title"),
      description: t("aboutUs.mission.cardTwo.description"),
    },
    // {
    //   title: t("aboutUs.mission.cardThree.title"),
    //   description: t("aboutUs.mission.cardThree.description"),
    // },
    // {
    //   title: t("aboutUs.mission.cardFour.title"),
    //   description: t("aboutUs.mission.cardFour.description"),
    // },
    {
      title: t("aboutUs.mission.cardFive.title"),
      description: t("aboutUs.mission.cardFive.description"),
    },

    {
      title: t("aboutUs.mission.cardSix.title"),
      description: t("aboutUs.mission.cardSix.description"),
    },
  ];

  return (
    <>
      <div className="w-100 bg-[#FFFFFF] z-[1]">
        <div className="mission relative max-w-[80%] z-[2] max-xxxl:max-w-[90%] m-auto mt-[109px] pb-[40px] mb-[118px] flex flex-col max-md:gap-[20px] gap-[43px] justify-center">
          <img
            src="../../assets/images/home/mission-back.png"
            alt=""
            className="absolute z-[-1] left-[28%] top-[7%] max-sm:hidden max-xxxl:left-[16%] max-xxxl:h-[400px] h-[600px] max-xxl:hidden"
          />
          <h2 className="heading-color tracking-[-3px] leading-[60px] font-sora">
            {t("aboutUs.mission.title")}{" "}
            <span className="words">{t("aboutUs.mission.subtitle")}</span>
          </h2>
          <div className="cards-wrapper grid grid-cols-1  lg:grid-cols-2 gap-[30px] px-[40px] max-sm:px-[0px]">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="py-[31px] px-[20px] border border-gray-400 shadow-lg rounded-[20px] bg-[#FFFFFF] "
              >
                <h6 className="font-bold leading-[20px] mb-[15px]">{card.title}</h6>
                <p className="large txt-color">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Ourmission;
